import React from 'react';
import styles from '../Delivery/Delivery.module.css'; // Импорт на CSS стиловете

const Delivery = () => {
    return(
        <div className={styles.deliverySection}>
            <h2>Правила за доставка</h2>
            <div className={styles.deliveryInfo}>
                <p>Ние изпращаме всички поръчки чрез куриерска фирма Еконт. Имайте предвид следната информация за доставка:</p>
                <ul>
                    <li><strong>Срок на доставка:</strong> Доставката отнема от 1 до 5 работни дни, в зависимост от местоположението на получателя и натовареността на куриерската фирма.</li>
                    <li><strong>Такси за доставка:</strong> Стойността на доставката се изчислява според тарифите на Еконт и се заплаща от клиента при получаване на пратката. При поръчка над 70 euro доставката е безплатна.</li>
                    <li><strong>Работни дни:</strong> Моля, имайте предвид, че куриерските услуги не работят през официални празници и почивни дни, което може да удължи срока за доставка.</li>
                </ul>
                <p>Ако имате допълнителни въпроси, може да се свържете с нас на theluminis@outlook.com</p>
            </div>
        </div>
    );
};

export default Delivery;
